import { PaginationWrapper, PaginationButton, PaginationTextButton } from "./styles";

export default function Pagination({ page, totalPages, onChange }) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <PaginationWrapper>
      <PaginationTextButton
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        Anterior
      </PaginationTextButton>
      {pages.map(p => (
        <PaginationButton
          key={p}
          onClick={() => onChange(p)}
          className={page === p ? "active" : ""}
        >
          {p}
        </PaginationButton>
      ))}
      <PaginationTextButton
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        Próximo
      </PaginationTextButton>
    </PaginationWrapper>
  );
}